import React, { Component } from 'react'
import { observer, inject } from "mobx-react";
import { withTranslation } from 'react-i18next';
import style from "./style.module.css";
import ReactTooltip from 'react-tooltip';

@inject((store) => {
    const { myShopApiStore, ifaceMngr } = store;
    return { myShopApiStore, ifaceMngr };
})

@observer
class EditCartPackForm extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            packItemsToOrder: this.getPackItems()
        }
    }
    
    getPackItems = () => {
        const { cartItemUpdating } = this.props.myShopApiStore;
        let packItemsToOrder = [];

        cartItemUpdating.steps.forEach(step => {
            step.packItems.forEach(packItem => {
                if(packItem.isReadyToOrder){
                    packItemsToOrder.push({packItem: packItem, stepNum: step.stepNum});
                }
            })
        })
        return packItemsToOrder;
    }

    closeForm = () => {
        const { closeCartItemForm, closeEditCartPackForm} = this.props.myShopApiStore;
        closeEditCartPackForm();
        closeCartItemForm();
    }

    changeItem = (packItemToOrder) => {
        const { closeEditCartPackForm, setStepNum} = this.props.myShopApiStore;
        const { stepNum } = packItemToOrder;
        setStepNum(stepNum);
        closeEditCartPackForm();
    }
    
    render() {
        const { cartItemUpdating } = this.props.myShopApiStore;
        const { t } = this.props;
        const { isRTL } = this.props.ifaceMngr;

        return (
            <div className={style.Container}>
                <div className={style.CloseButton}>
                    <button onClick={this.closeForm}>✕</button>
                </div>
                <div className={style.CartItemName}>{cartItemUpdating.item.product.name}</div>
                <div className={style.PackItems}>
                    {
                        this.state.packItemsToOrder.map((packItemToOrder, idx) => {
                            return(
                                <div key={idx} className={style.PackItemToOrder}>
                                    <div className={style.RightElements}>
                                        <div className={style.ItemImage}>
                                            <img
                                                width='70px'
                                                src={packItemToOrder.packItem.item.product ? packItemToOrder.packItem.item.product.image : ""}
                                                alt={packItemToOrder.packItem.item.product ? packItemToOrder.packItem.item.product.description : ""}
                                            />
                                        </div>
                                        <div className={style.ItemDetails}>
                                            <div className={style.ItemName}>
                                                {packItemToOrder.packItem.item.product.name}
                                            </div>
                                            <div className={style.ItemQuantity}>
                                                {t('Quantity')}: {packItemToOrder.packItem.quantity} {(packItemToOrder.packItem.item.unitTypes[0].type == 'unit') ? '' : t(packItemToOrder.packItem.item.unitTypes[0].type)}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={style.LeftElements}>
                                        <div className={style.MoreInfoTooltip}>
                                            {
                                                packItemToOrder.packItem.item.product.description && 
                                                <>
                                                    <div data-tip={packItemToOrder.packItem.item.product.description} data-for={`moreInfo_${packItemToOrder.packItem.id}`}>?</div>
                                                    <ReactTooltip
                                                        className={style.Tooltip}
                                                        place={ isRTL ? 'right' : 'left' }
                                                        multiline={true}
                                                        data-html={true}
                                                        insecure={true} 
                                                        id={`moreInfo_${packItemToOrder.packItem.id}`}
                                                        type='light'
                                                        border={true}
                                                        effect='solid'
                                                    />
                                                </>
                                            }
                                        </div>
                                        <div className={style.ChangeItemBtn}>
                                            <button onClick={() => this.changeItem(packItemToOrder)}>
                                                {t('Change product')}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                {/* <button onClick={this.closeForm}>close</button> */}
            </div>
        )
    }
}

export default withTranslation()(EditCartPackForm);
